import { render } from "./quote.vue?vue&type=template&id=acf0663e&scoped=true"
import script from "./quote.vue?vue&type=script&lang=js"
export * from "./quote.vue?vue&type=script&lang=js"

import "./quote.vue?vue&type=style&index=0&id=acf0663e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf0663e"]])

export default __exports__